---
title: Leetcode Solutions
coverImage: https://picsum.photos/200
date: 2023-11-10T18:55:37.000Z
updated: 2023-11-10T18:55:37.000Z
excerpt: Template for project reports
hidden: true
tags:
  - Leetcode
---

<script>import Image from "@lib/components/atoms/Image.svelte";</script>

### General idea

What is the thing I'm trying to make?

## Links, inspiration, etc

## Learnings

## Todo

### Tests
for longest common prefix
try cumuilative substring hash vs is parallel incremental xor faster than equality checking for many short strings

- [x] Write the press release
- [ ] Update the website
- [ ] Contact the media
